import { useEffect } from 'react'
import { useAuth } from 'store/selectors'
import useAuthActions from 'store/actions/auth'
import Main from 'components/Main'
import Auth from 'components/Auth'
import './App.css'
import Modals from 'components/modals'

const App = () => {
  const { authUser, restoring } = useAuth()
  const { restoreSession } = useAuthActions()

  useEffect(() => {
    restoreSession()
  }, [restoreSession])

  // While a kept sign-in is tried, nothing: the iframe would only flash
  // before Main replaced it.
  return (
    <>
      {authUser ? <Main /> : restoring ? null : <Auth />}
      <Modals />
    </>
  )
}

export default App
